import { IconLoader2 } from '@tabler/icons-react';

const SuspenseFallback = () => (
  <div className="flex h-full w-full items-center justify-center">
    <IconLoader2 className="animate-spin text-[#005b92]" size={32} />
  </div>
);

export default SuspenseFallback;
